<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog title="学籍卡导出" :visible.sync="dialogVisible" width="900px">
            <span>
                <el-form>
                    <div style="width: 100%" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>

                                            <span v-field-lbl="'className'" class="field">入学年份</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <el-select v-model="year" placeholder="请选择" style="width: 100%" @change="changeYear">
                                                <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'majorName'" class="field">专业</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5" disabled="true">
                                            <el-select v-model="formData.majorId" placeholder="请选择" style="width: 100%" @change="changeMajor">
                                                <el-option v-for="item in majorList" :key="item.id" :label="item.text" :value="item.id"></el-option>
                                            </el-select>
                                        </td>
                                    </tr> -->
                                    <tr v-if="isShow">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span v-field-lbl="'className'" class="field">班级</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <form-item
                                                key="class"
                                                ref="className"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: 1,
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 1,
                                                    elementType: 'input',
                                                    emptyMessage: '请选择班级',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 0,
                                                    onClickEvent: '',
                                                    passenger: {},
                                                    propComment: '班级',
                                                    propName: 'className',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'formData.className',
                                                    option: [],
                                                    dialog: 1,
                                                    dialogType: 'listpage',
                                                    dialogMultiple: false,
                                                    dialogListviewurl: 'school.clazz.list_YReWtN?urlsearch=' + urlsearch,
                                                    dialogTitle: '选择班级'
                                                }"
                                                :vo="formData"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </span>
            <div style="color: #1a82e3; margin-top: 8px">
                <i class="el-icon-warning" style="margin-right: 4px"></i>
                不做任何操作时默认导出具有管理权限下的所有学籍卡；如需导出某个班级的学籍卡，请按条件进行筛选操作。
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmClick">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            formData: {
                className: '',
                majorId: ''
            },
            year: null,
            major: '',
            yearList: [],
            majorList: [],
            urlsearch: '',
            isShow: true
        }
    },
    computed: {
    },
    created() {
        console.log('bathEditDialog--------')
        this.$bus.on('openAddRecord', this.openAddRecord)
    },
    beforeDestroy() {
        this.$bus.off('openAddRecord', this.openAddRecord)
    },
    mounted() {
        let year = new Date().getFullYear()
        this.yearList.push(
            {
                label: year + '年',
                value: year
            },
            {
                label: year - 1 + '年',
                value: year - 1
            },
            {
                label: year - 2 + '年',
                value: year - 2
            },
            {
                label: year - 3 + '年',
                value: year - 3
            },
            {
                label: year - 4 + '年',
                value: year - 4
            }
        )
        let roles = this.$store.getters.roles
        this.urlsearch = ''
        if (roles.indexOf('dwAdministrators') === -1) {
            this.urlsearch = 'teacherId:' + this.$store.getters.loginUser.personId
        }
    },
    methods: {
        changeMajor(val) {
            this.formData.majorId = val
        },
        changeYear(val) {
            this.year = val
            this.isShow = false
            if (this.$store.getters.roles.indexOf('dwAdministrators') === -1) {
                this.urlsearch = 'teacherId:' + this.$store.getters.loginUser.personId + ';schoolYear:' + this.year
            } else {
                this.urlsearch = 'schoolYear:' + this.year
            }
            setTimeout(() => {
                this.isShow = true
            }, 100)
            // this.year = val
            // let params = {
            //     year: val
            // }
            // this.$http({
            //     method: 'GET',
            //     params: params,
            //     url: `/xsgl/schoolMajors/getMajorsOptions`
            // }).then((res) => {
            //     if (res.code === 'success') {
            //         this.majorList = res.body.options
            //     }
            // })
        },
        openAddRecord() {
            this.dialogVisible = true
            this.formData = {
                className: '',
                classId: ''
            }
        },
        confirmClick() {
            if(!this.year){
                this.$message.warning('请选择学年')
                return
            }
            this.formValidate(
                () => {
                    const params = {
                        classId: this.formData.classId,
                        admissionYear: this.year
                    }
                    this.$http({
                        method: 'GET',
                        contentType: 'application/x-www-form-urlencoded',
                        params: params,
                        url: `/xsgl/studentBasicInfo/batPrintCpbFileDoc`
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success('提交成功')
                            this.dialogVisible = false
                            this.$bus.emit('refreshListData')
                        }
                    })
                },
                null,
                1
            )
        },
        onSelectListpageRowCompleted: function (val, arr) {
            const item = val[0]
            const { name } = arr
            if (name === 'majorName') {
                this.formData.majorName = item.majorName
                this.formData.majorId = item.id
            } else if (name === 'className') {
                this.formData.className = item.className
                this.formData.classId = item.classId
                // this.formData.majorName = item.passenger.majorName
                // this.formData.majorId = item.passenger.majorNameId
            }
            console.log(item)
        }
    }
}
</script>

<style></style>
